import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-upload-materials';

export const uploadContentMaterials = ({
  pageId,
  type,
  status,
  category,
  files,
  items,
  managerId,
}: contentApiTypes.UploadMaterialsParams) => {
  const formData = new FormData();
  formData.append('pageId', pageId);
  formData.append('type', type);
  formData.append('status', status);
  if (category) {
    formData.append('category', category);
  }
  if (managerId) {
    formData.append('managerId', managerId);
  }
  if (items?.length) {
    formData.append('items', JSON.stringify(items));
  }
  files.forEach((file) => {
    formData.append('files', file);
  });

  return axios.post('/content/materials/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }) as Promise<contentApiTypes.UploadMaterialsResponse>;
};

type UploadContentMaterialsOptions = {
  config?: MutationConfig<typeof uploadContentMaterials>;
  /** Skip built-in toast and cache invalidation — caller owns feedback for per-file flows. */
  silent?: boolean;
};

export const useUploadContentMaterials = ({
  config = {},
  silent = false,
}: UploadContentMaterialsOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: uploadContentMaterials,
    onMutate: (variables) => {
      if (!silent) {
        toasts.loadingToast.loading(TOAST_ID, 'Загрузка файлов...');
      }
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      if (!silent) {
        toasts.loadingToast.success(TOAST_ID, 'Файлы загружены');
        queryClient.invalidateQueries(['content-materials', variables.pageId]);
      }
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      if (!silent) {
        toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      }
      onError?.(error, variables, context);
    },
  });
};
